import { render, staticRenderFns } from "./FormCollectionForm.vue?vue&type=template&id=d5e487b0&scoped=true&"
import script from "./FormCollectionForm.vue?vue&type=script&lang=js&"
export * from "./FormCollectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5e487b0",
  null
  
)

export default component.exports